export type InstallPlatform = 'ios' | 'android' | 'harmony';
export type InstallStepIcon = 'share' | 'menu' | 'grid' | 'home' | 'check';
type PlatformGuide = {
  label: string;
  hint: string;
  steps: Array<{ icon: InstallStepIcon; title: string; text: string }>;
  tip: string;
};

export const INSTALL_PLATFORMS: Record<InstallPlatform, PlatformGuide> = {
  ios: {
    label: 'iPhone', hint: '先用 Safari 打开，再添加到主屏幕',
    steps: [
      { icon: 'share', title: '点「分享」按钮', text: '在 Safari 中找到分享图标或「共享」' },
      { icon: 'home', title: '选「添加到主屏幕」', text: '向下滑动分享菜单，找到这项操作' },
      { icon: 'check', title: '点「添加」完成', text: '保留名称「练刻」，确认后返回桌面' },
    ],
    tip: '若有「作为网页 App 打开」开关，请开启后再添加。找不到添加项时，可在「编辑操作」中查找。',
  },
  android: {
    label: '安卓', hint: '在浏览器自己的菜单中添加，无需重新输入网址',
    steps: [
      { icon: 'menu', title: '先关闭引导，打开浏览器菜单', text: '点浏览器的三点、四点或三横线菜单' },
      { icon: 'home', title: '找「添加到桌面」', text: '也可能叫「添加至主屏幕」或「安装应用」；以浏览器实际菜单为准' },
      { icon: 'check', title: '确认添加', text: '按提示允许添加，返回桌面查看图标' },
    ],
    tip: '小米浏览器各版本入口可能不同。若菜单没有添加选项，可先保存书签；也可用手机上支持添加桌面的其他浏览器打开。复制网址不会自动创建图标。',
  },
  harmony: {
    label: '鸿蒙', hint: '在华为浏览器菜单中添加，无需重新输入网址',
    steps: [
      { icon: 'grid', title: '先关闭引导，点右下角四个点', text: '这是华为浏览器的菜单，位于网页内容之外' },
      { icon: 'home', title: '选「添加至桌面」', text: '旧版系统：选「添加至」→「桌面」' },
      { icon: 'check', title: '确认添加', text: '返回桌面，点击「练刻」图标即可进入' },
    ],
    tip: '鸿蒙 5.0 及以上若菜单里找不到：浏览器「我的」→「历史记录」→「网页」，长按当前网站→「添加至桌面」。也可从「书签收藏」中的书签长按添加。',
  },
};
